import type { MetaFunction } from "@remix-run/cloudflare";
import { Outlet } from "@remix-run/react";

export const meta: MetaFunction = () => [
  { title: "Naomi — Prodigium Dynamics" },
  { name: "description", content: "Naomi — your AI connection layer. A calm companion to check in, wind down, and talk things through." },
];

// Pass-through layout: each child route (login / chat) owns its own full
// presentation, so the parent just renders the nested route. Mirrors the
// account.* layout pattern.
export default function NaomiLayout() {
  return <Outlet />;
}
